import { render, staticRenderFns } from "./modal_exclusao_anamnese.vue?vue&type=template&id=036fc34c&scoped=true"
import script from "./modal_exclusao_anamnese.vue?vue&type=script&lang=js"
export * from "./modal_exclusao_anamnese.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036fc34c",
  null
  
)

export default component.exports